
const Header = () => {
  return (
    <div className="mb-8 md:mb-12 animate-fade-in relative">
      <div className="text-center">
        <h1 className="text-4xl md:text-6xl font-bold text-[#6B4EE6] mb-3 md:mb-4 tracking-tight">
          CardCombiner
        </h1>
        <p className="text-lg md:text-xl text-[#6B4EE6]/80 font-medium px-4">
          Upload up to 9 images and combine them into one!
        </p>
      </div>
    </div>
  );
};

export default Header;
